"use client"

import { getDepictMarketCode } from "@/app/(site)/_utils/misc"
import useEcommerceStore from "@/app/(site)/contexts/ecommerce/store"
import React, { useEffect } from "react"
import useDepictClientSessionId from "@/lib/depict-client/helpers/useDepictClientSessionId"

const DepictPerformanceClient = () => {
    const { countryCode } = useEcommerceStore(state => ({
        countryCode: state.centraSession.metadata.country.code
    }))
    const depictSessionId = useDepictClientSessionId()
    useEffect(() => {
        if (!window.WeakRef) {
            window.WeakRef = class WeakRef<T extends object> {
                private weakMap: WeakMap<WeakRef<T>, T>

                constructor(target: T) {
                    this.weakMap = new WeakMap()
                    this.weakMap.set(this, target)
                }

                deref(): T | undefined {
                    return this.weakMap.get(this)
                }

                // Adding the [Symbol.toStringTag] property to satisfy TypeScript's WeakRef interface
                get [Symbol.toStringTag](): string {
                    return "WeakRef"
                }
            } as any
        }
        if (!countryCode) {
            return
        }
        import("@depict-ai/dpc").then(({ DPC }) => {
            new DPC(process.env.DEPICT_MERCHANT || "poc", {
                market: getDepictMarketCode(countryCode)
            }).setSessionId(depictSessionId)
        })
    }, [countryCode, depictSessionId])

    return null
}

export default React.memo(DepictPerformanceClient)
